import { deepmerge } from '@mui/utils';
import { createTheme, useTheme, svgIconClasses } from '@mui/material';
import { blue } from '@mui/material/colors';

const customBlue = { C100: '#0078AE' } as const;

declare module '@mui/material/styles' {
  interface Palette {
    early: {
      main: string;
      dark: string;
    };
    blue: typeof customBlue & typeof blue;
  }
}

const customTheme = () => {
  const theme = useTheme();

  return createTheme(
    deepmerge(theme, {
      palette: {
        primary: {
          main: '#8400FF',
          dark: '#440082',
        },
        early: {
          main: '#8400FF',
          dark: '#440082',
        },
        urgent: {
          main: '#440082',
          light: '#F5E1FF',
          dark: '#440082',
          contrastText: '#FFFFFF',
        },
        blue: { ...blue, ...customBlue },
      },
      shape: {
        borderRadius: 4,
      },
      typography: {
        // overriding Bootstrap to expected EDS header colors
        'h4': {
          color: theme.palette.grey[900],
        },
        'h5': {
          color: theme.palette.grey[900],
        },
        'h6': {
          color: theme.palette.grey[900],
        },
        'subtitle2': {
          color: theme.palette.grey[900],
        }
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            body: {
              borderBottomColor: theme.palette.grey[200],
            },
            head: {
              borderBottomColor: theme.palette.grey[400],
            },
          },
        },
        MuiTooltip: {
          defaultProps: {
            arrow: true,
          },
          styleOverrides: {
            tooltip: {
              ...theme.typography.body1,
              backgroundColor: theme.palette.grey[800],
            },
            arrow: {
              color: theme.palette.grey[800],
            },
          },
        },
        MuiIcon: {
          defaultProps: {
            baseClassName: 'material-icons-outlined',
          },
          styleOverrides: {
            root: {
              [`&.MuiIcon-fontSizeMedium, &.${svgIconClasses.fontSizeMedium}`]: {
                fontSize: 24,
              },
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              input: {
                position: 'absolute'
              },
            }
          }
        },
        MuiSelect: {
          // The MUI Theme is affecting the EDS Select component so we have to override it here
          styleOverrides: {
            select: {
              marginRight: 0
            }
          }
        },
        MuiSnackbar: {
          styleOverrides: {
            root: {
              'h6': {
                display: 'inline'
              },
            }
          }
        }
      },
    }),
  );
};

export default customTheme;
